<template>
    <div class="footer-wrap">
        <div class="footer-tips">
          © {{ new Date().getFullYear() }} {{ $t('footer_text1') }}
        </div>
        <div class="footer-copyright">
            <p style="margin: 0;">{{ $t('footer_text2') }}<a
                style="color: #007cb0;"
                :href="aboutDeloitteLink"
                target="_blank"
                rel="noopener noreferrer"
              >{{ $t('footer_text3') }}</a>{{ $t('footer_text4') }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "AppFooter",
    computed: {
        aboutDeloitteLink() {
            if (this.$i18n.locale === 'en-US') {
                return 'https://www.deloitte.com/cn/en/about/governance/network-brand-alliances.html?icid=toggle_cn_en';
            }
            return 'https://www.deloitte.com/cn/zh/about/governance/network-brand-alliances.html';
        }
    }
}
</script>

<style scoped lang="less">
.footer-wrap {
  line-height: 19px;
  width: 100%;
  font-size: 12px;
  background-color: #000;
}
@media screen and (min-height: 1012px) {
  .footer-wrap {
      position: fixed;
      bottom: 0;
      z-index: 9;
      width: 100%;
      font-size:12px;
  }
}
.footer-tips {
    background-color: #000;
    width: 100%;
    padding: 25px 50px 0;
    color: #bbbcbc;
    border: none;
    margin: 0;
}
.footer-copyright {
    width: 100%;
    padding: 10px 50px 20px;
    background-color: #000;
    color: #bbbcbc;
    box-sizing: border-box;
    border: none;
    margin: 0;
}

@media (max-width: 768px) {
  .footer-wrap {
    position: static !important;
  }
  .footer-tips,
  .footer-copyright {
    padding-left: 16px;
    padding-right: 16px;
    border: none;
    box-shadow: none;
  }
  .footer-tips {
    padding-top: 16px;
    padding-bottom: 0;
  }
  .footer-copyright {
    padding-top: 8px;
    padding-bottom: calc(16px + env(safe-area-inset-bottom, 0px));
    font-size: 11px;
    line-height: 1.4;
    margin-top: -1px;
  }
}
</style>
